import * as React from 'react';
import { Card, cn } from 'shadcn-ui';

export function ShadowedCard({ className, ...props }: React.ComponentProps<typeof Card>) {
  return <Card className={cn('shadow-sm', className)} {...props} />;
}
